export default {
  // Backend-related states

  // The backend fetching endpoint
  fetchEndpoint: "",
  // The backend sending endpoint
  sendEndpoint: "",
  // The method used to send data to the backend (post, put, etc.)
  method: "",
  // If the data is fetching from the backend
  fetching: true,
  // If the data is sending into the backend
  sending: false,
  // Functions set that adapts the data before reaching or sending it to the frontend
  adapter: {
    in: null,
    out: null,
    out_header: "",
    out_options: {}
  },

  // Validation states

  // If the forms are validating (used for watches in components)
  validating: false,
  // If the form is valid
  valid: true,
  // The number of individual validations run in the global form
  validations: 0,
  // The number of individual errors found in the global form
  errors: 0,
  /* An optional fixed size (positive integer) representing the number of forms to validate.
   * It is more useful when using validation, but not the data part of the tool. */
  fixedSize: null,

  // Tool-related states

  // ID counter
  counter: 0,
  // Current data set of the form
  data: [],
  // Distance in terms of undo/redo from the data that references the last change
  referenceDistance: 0,
  // Stack containing the undo history
  undo: [],
  // Stack containing the redo history
  redo: []
};
